module.exports = __webpack_public_path__ + "img/Salad.510109a6.jpg";